module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "shaping-leaders.c865a2f8.webp" + "?" + Date.now();